module.exports = __webpack_public_path__ + "static/media/LVS_All_Done.a2208ff7.svg";